import config from '../../config'

import { IGetPutRequest } from '../../interfaces'

const getCompleteChecklistMutationRequest: IGetPutRequest = params => {
  const { airportId, id } = params

  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/Checklists/instances/${id}/Complete`,
  }
}

export default getCompleteChecklistMutationRequest
